export const setTempFavoriteMenuAction = (menuId, isFavorite) => {
    return {
        type: 'SET_TEMP_FAV_MENU',
        isFavorite,
        menuId
    }
}